// Pile du wallet (voir oqp-design.css, « Pile du wallet »). Porté de sections/wallet.js du prototype.
// Dans Shopify, chaque carte vit dans le wrapper de sa section (.wallet-slot, classe posée par le
// schema de la section) : c'est ce wrapper qui colle. #MainContent[data-wallet] joue le rôle de #wallet.
// Le JS calcule seulement où chaque carte colle et, pendant que la suivante la recouvre, la fait
// descendre à son emplacement et l'assombrit.
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const smooth = t => t * t * (3 - 2 * t);

function initWallet() {
  const wallet = document.querySelector('[data-wallet]');
  if (!wallet) return;
  let cards = [];
  let navH = 91, tab = 40, stick = [], tall = [], shift = [], ticking = false;

  function collect() {
    cards = [...wallet.querySelectorAll(':scope > .wallet-slot')];
    shift = cards.map(() => 0);
    cards.forEach((c, i) => { c.style.zIndex = String(i + 1); });
  }

  function measure() {
    if (!cards.length) return;
    const cs = getComputedStyle(wallet);
    tab = parseFloat(cs.getPropertyValue('--tab')) || 32;
    const overlap = parseFloat(cs.getPropertyValue('--overlap')) || 0;
    const tuck = parseFloat(cs.getPropertyValue('--tuck')) || 0;   // la pile glisse un peu sous la nav
    const nav = document.querySelector('.nav');
    navH = (nav ? nav.getBoundingClientRect().height : 91) - tuck;
    const last = cards.at(-1);
    stick = cards.map((c, i) => {
      const slot = navH + i * tab;
      const visible = c.offsetHeight - (c === last ? 0 : overlap);
      if (c === last) return slot;                         // la dernière se cale toujours à son emplacement
      return Math.min(slot, innerHeight - visible);        // trop haute : colle quand son bas visible est à l'écran
    });
    // une carte plus haute que la fenêtre ne descend pas à son emplacement (Safari ajouterait ce
    // glissement à la longueur de la page) : elle se fait juste recouvrir
    tall = cards.map((c, i) => i < cards.length - 1 && c.offsetHeight > innerHeight - navH);
    cards.forEach((c, i) => c.style.setProperty('--stick', `${stick[i]}px`));
    // la dernière carte remplit la fenêtre sous son emplacement, quel que soit le nombre de cartes
    wallet.style.setProperty('--fill', `${Math.max(0, innerHeight - (navH + (cards.length - 1) * tab))}px`);
    update();
  }

  function update() {
    ticking = false;
    cards.forEach((card, i) => {
      const next = cards[i + 1];
      if (!next || reduced) return;
      const y = next.getBoundingClientRect().top - shift[i + 1];
      const start = innerHeight, end = navH + (i + 1) * tab;
      const t = clamp((start - y) / (start - end), 0, 1);
      const slot = navH + i * tab;
      shift[i] = tall[i] ? 0 : Math.max(0, (slot - stick[i]) * smooth(t));
      card.style.setProperty('--shift', `${shift[i]}px`);
      card.style.setProperty('--dim', (.3 * smooth(clamp((t - .6) / .4, 0, 1))).toFixed(3));
    });
    // masque ce qui dépasse sous la carte du dessus (et ses coins arrondis)
    cards.forEach((card, i) => {
      const next = cards[i + 1];
      if (!next) return;
      const hidden = card.getBoundingClientRect().bottom - (next.getBoundingClientRect().top + 60);
      card.style.clipPath = hidden > 0 ? `inset(-300px -60px ${hidden}px -60px)` : '';
    });
  }

  collect();
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener('resize', measure);
  new ResizeObserver(measure).observe(wallet);
  // éditeur de thème : sections ajoutées, supprimées ou rechargées
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(type =>
    document.addEventListener(type, () => requestAnimationFrame(() => { collect(); measure(); })));
  measure();

  // Liens vers une carte (« L'appli » → /#appli…) : le navigateur sauterait là où la carte est *collée*.
  // On défile plutôt jusqu'à sa vraie place, pour qu'elle arrive à son emplacement.
  function goTo(card, behavior) {
    const i = cards.indexOf(card);
    const keep = [card.style.position, card.style.translate];
    card.style.position = 'static'; card.style.translate = 'none';
    const top = card.getBoundingClientRect().top + scrollY;
    [card.style.position, card.style.translate] = keep;
    scrollTo({ top: Math.max(0, top - (navH + i * tab)), behavior });
  }
  const cardOf = hash => {
    let el = null;
    try { el = hash && hash.length > 1 && document.getElementById(decodeURIComponent(hash.slice(1))); } catch {}
    return el && wallet.contains(el) ? cards.find(c => c.contains(el)) : null;
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname) return;
    const card = cardOf(url.hash);
    if (!card) return;
    e.preventDefault();
    history.pushState(null, '', url.hash);
    goTo(card, reduced ? 'auto' : 'smooth');
  });
  const arriving = cardOf(location.hash);
  if (arriving) {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    const go = () => { measure(); goTo(arriving, 'auto'); };
    document.readyState === 'complete' ? go() : addEventListener('load', go, { once: true });
  }
}

initWallet();
